window.shopifyFetch = async function shopifyFetch(query, variables, options) {
  variables = variables || {};
  options = options || {};

  var storeDomain = '3d54b1-24.myshopify.com';
  var storefrontAccessToken = 'e568a4e85eae05f90490fc8e90b40098';

  var fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query: query, variables: variables })
  };

  if (options.signal) {
    fetchOptions.signal = options.signal;
  }

  var response = await fetch('https://' + storeDomain + '/api/2025-01/graphql.json', fetchOptions);
  var result = await response.json();

  if (result.errors) {
    console.error('GraphQL Errors:', result.errors);
    return null;
  }

  return result.data;
};
